export function formatPhone(phone: string | null | undefined): string {
  if (!phone) return "—";
  const stripped = phone.replace(/\s+/g, "").replace(/[()]/g, "");
  let digits: string;
  let prefix = "";

  if (stripped.startsWith("+48")) {
    digits = stripped.slice(3);
  } else if (stripped.startsWith("+")) {
    const m = stripped.match(/^(\+\d{1,3})(\d+)$/);
    if (m) {
      prefix = m[1] + " ";
      digits = m[2];
    } else {
      return phone;
    }
  } else {
    digits = stripped.replace(/\D/g, "");
  }

  const spaced = digits.replace(/(\d{3})(?=\d)/g, "$1 ");
  return prefix + spaced;
}
